import cx from "classnames";
import React from "react";

import { ContestEntity, ContestType } from "@/mk2/apps/forum/schemas";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { CONTEST_AMBASSADOR_TAG, CONTEST_FINISHED_TAG } from "@/mk/autogenerated/translations/ContestItem.282d41ecf5df93b1e9eacc40ea60e780";

import styles from "./ContestItem.mscss";

interface OwnProps {
    className?: string;
    contest: ContestEntity;
    isMobile: boolean;
    style?: React.CSSProperties;
}

type Props = OwnProps;

const CONTEST_PHOTO_VERSIONS: { [type in ContestType]: string } = {
    [ContestType.Article]: "s560x560",
    [ContestType.Forum]: "s150x150",
    [ContestType.ShortMessage]: "s165x165",
};

const ContestItem: React.FunctionComponent<Props> = ({ className, contest, style }) => (
    <Link to={contest.url} style={style} className={cx(styles.ContestItem, className)}>
        <div className={styles.ContestItem__image}>
            {contest.photo && (
                <ImgCropped
                    mode={ImgCropMode.Cover}
                    photo={contest.photo}
                    alt={contest.title}
                    photoVersion={CONTEST_PHOTO_VERSIONS[contest.type]}
                    width={50}
                    height={50}
                />
            )}
        </div>
        <div
            className={cx(
                styles.ContestItem__title,
                contest.isActive && styles["ContestItem__title--active"],
            )}
        >
            {contest.title}
            {contest.blogPostId && (
                <span className={styles.ContestItem__title__note}> ({CONTEST_AMBASSADOR_TAG})</span>
            )}
            {!contest.isDraft && !contest.isActive && (
                <span className={styles.ContestItem__title__finishedBadge}>
                    {CONTEST_FINISHED_TAG}
                </span>
            )}
        </div>
        <div className={styles.ContestItem__count}>{contest.replyCount}</div>
    </Link>
);

ContestItem.displayName = "ContestItem";

export default ContestItem;

interface PlaceholderOwnProps {
    className?: string;
    isMobile: boolean;
    style?: React.CSSProperties;
}

export const ContestItemPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({
    className,
    style,
    isMobile,
}) => (
    <div style={style} className={cx(styles.ContestItem, className)}>
        <div className={styles.ContestItem__image}>
            <LoadingPlaceholder width={50} height={50} />
        </div>
        <div className={styles.ContestItem__title}>
            <LoadingPlaceholder width={isMobile ? 320 : 550} height={30} />
        </div>
    </div>
);
ContestItemPlaceholder.displayName = "ContestItemPlaceholder";
